import $ from 'jquery';
import BaseEvent from './base-event';

export default class LinkEvents extends BaseEvent {
  constructor() {
    super({
      event_id: '10',
      category: 'link',
      action: 'click',
    });

    this.init();
  }

  init() {
    this.onArticleLinksClick();
    this.onMostReadLinksClick();
    this.onArticleHeaderLinksClick();
    this.onFreeformComponentLinksClick();
    this.onFixturesLinksClick();
    this.onPlayersLinksClick();
    this.onPartnersLinksClick();
  }

  onArticleLinksClick() {
    $('.article-body').find('a').on('click', (e) => {
      this.fireEvent({
        label: this.toNormalizedString(e.currentTarget.innerText),
        destination_url: e.currentTarget.href,
      });
    });
  }

  onMostReadLinksClick() {
    $('.most-read__list').find('a').on('click', (e) => {
      this.fireEvent({
        label: this.toNormalizedString(e.currentTarget.innerText),
        destination_url: e.currentTarget.href,
      });
    });
  }

  onArticleHeaderLinksClick() {
    $('.article-header').find('a:not(.mc-button)').on('click', (e) => {
      this.fireEvent({
        label: this.toNormalizedString(e.currentTarget.innerText),
        destination_url: e.currentTarget.href,
      });
    });
  }

  onFreeformComponentLinksClick() {
    $(`.ff-section__content .mc-arrowed-link,
      .next-fixtures .mc-arrowed-link,
      .ff-summary-link-section__link,
      .ff-fancy-link-list__link,
      .ff-rich-text a,
      .ff-detailed-link-list__item-link,
      .ff-download-list__link,
      .ff-info-card-component__link:not(.mc-button),
      .ff-info-card__footer a,
      .ff-table-of-contents__item a,
      .ff-section__content .container p a,
      .sc-info-card__footer a`).on('click', (e) => {
      const label = this.getLabel($(e.currentTarget));
      this.fireEvent({
        label: this.toNormalizedString(label),
        destination_url: e.currentTarget.href,
      });
    });

    $(`.ff-primary-link-card__container,
      .sc-primary-link-card__container,
      .sc-secondary-link-card__container`).on('click', (e) => {
      this.fireEvent({
        label: this.toNormalizedString($(e.currentTarget).find('[class*=__heading]').text()),
        destination_url: e.currentTarget.href,
      });
    });
  }

  onFixturesLinksClick() {
    $(`.add-to-calendar,
      .fixture-tickets__list a:not('.mc-button'),
      .result-links-list a`).on('click', (e) => {
      const label = this.getLabel($(e.currentTarget));
      this.fireEvent({
        label: this.toNormalizedString(label),
        destination_url: e.currentTarget.href,
      });
    });
  }

  onPlayersLinksClick() {
    $('.social-sidebar a').on('click', (e) => {
      this.fireEvent({
        label: this.toNormalizedString(e.currentTarget.innerText),
        destination_url: e.currentTarget.href,
      });
    });
  }

  onPartnersLinksClick() {
    $(document).on('click', '.partners-list__link', (e) => {
      const label = $(e.currentTarget).find('img').attr('title');
      this.fireEvent({
        label: this.toNormalizedString(label),
        destination_url: e.currentTarget.href,
      });
    });
  }
}
